<template>
  <v-container
    id="sparepartsorder"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-basket-fill"
      class="px-5 py-3"
      width="100%"
      :title="`Ordine Ricambi ${lineaSelected?.label||''}`"
    >
      <v-row
        v-if="!$vuetify.breakpoint.lgAndUp"
        no-gutters
        justify="end"
      >
        <v-icon
          :color="cart.length>0?'red':'grey'"
          @click="showCart=!showCart"
        >
          {{ cart.length>0?'mdi-cart':'mdi-cart-outline' }}
        </v-icon>
      </v-row>

      <v-row class="mt-4">
        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model="lineaSelected"
            dense
            label="Linea Occhiale"
            :items="listaLinee"
            item-text="label"
            item-value="codlin"
            return-object
            single-line
            outlined
            @change="get_spareparts();selectedParts=null;"
          />
          <v-list
            v-if="components.length>0"
            dense
          >
            <v-subheader>Ricambi</v-subheader>

            <template
              v-for="(item,i) in [...new Set(parts.map(item =>
                JSON.stringify({ compo: item.compo, nomcom: item.nomcom, sez: item.sez, tippar: item.tippar })
              ))].map(item => JSON.parse(item))"
            >
              <v-list-item
                v-if="parts.length>0"
                :key="`p${i}`"
                @click="dialogRicambi = true;selectedCmp=null; selectedParts=item"
              >
                <!--
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                -->
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.nomcom"
                  />
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.lgAndUp"
          cols="12"
          sm="8"
        >
          <!-- cart -->
          <spareparts-cart @save="saveSpareparts" />
        </v-col>
      </v-row>
    </base-material-card>
    <v-dialog
      v-if="!$vuetify.breakpoint.lgAndUp"
      v-model="showCart"
      max-width="1024"
    >
      <v-card class="pa-4">
        <v-row
          justify="end"
          no-gutters
          class="mb-2"
        >
          <v-icon @click="showCart=false">
            mdi-close
          </v-icon>
        </v-row>
        <spareparts-cart @save="saveSpareparts" />
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRicambi"
      max-width="800"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ selectedParts?.nomcom }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="8"
            >
              <v-autocomplete
                v-model="selectedCmp"
                outlined
                :items="items"
                :rules="[rules.required]"
                color="blue-grey lighten-2"
                :label="selectedParts?.nomcom"
                item-text="descompo"
                return-object
                clearable
                class="ma-0 pa-0 text-body-1"
                height="55px"
                @change="selectedQta=null;selectedColor=null"
              >
                <template v-slot:selection="data">
                  <v-avatar
                    rounded
                    left
                  >
                    <v-img
                      :src="filepath(data.item.dir,data.item.tippar)"
                      :lazy-src="filepath(data.item.dir,data.item.tippar)"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-img
                          src="img/xxx.png"
                        />
                      </template>
                    </v-img>
                  </v-avatar>

                  <span class="pl-4">{{ data.item.descompo }}</span>
                </template>
                <template
                  v-slot:item="data"
                >
                  <v-list-item-avatar
                    rounded
                    width="120"
                    max-height="50"
                  >
                    <v-img
                      :src="filepath(data.item.dir,data.item.tippar)"
                      :lazy-src="filepath(data.item.dir,data.item.tippar)"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-img
                          src="img/xxx.png"
                        />
                      </template>
                    </v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <span class="pl-4">{{ data.item.descompo }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="selectedCmp?.compo && listaColori.filter(item => (item.numcol !== selectedCmp.numcol)).length>1">
            <v-col
              cols="12"
              md="8"
            >
              <v-autocomplete
                v-model="selectedColor"
                outlined
                :items="listaColori"
                :rules="[rules.required]"
                color="blue-grey lighten-2"
                label="colori"
                item-text="descol"
                :hint="listaColori.filter(item => (item.numcol !== selectedCmp.numcol)).length+' colori disponibili'"
                persistent-hint
                return-object
                class="ma-0 pa-0 text-body-1"
                height="55px"
                clearable
                @change="selectedColor?selectedCmp=selectedColor:null"
              >
                <template v-slot:selection="data">
                  <v-avatar
                    rounded
                    left
                  >
                    <v-img
                      :src="`img/COL/${lineaSelected.label}_${data.item.numcol}.png`"
                      max-height="40"
                      contain
                    />
                  </v-avatar>

                  <span class="pl-4">{{ data.item.numcol }} {{ data.item.descol }}</span>
                </template>
                <template
                  v-slot:item="data"
                >
                  <v-list-item-avatar
                    rounded
                    width="120"
                    max-height="40"
                  >
                    <v-img
                      :src="`img/COL/${lineaSelected.label}_${data.item.numcol}.png`"
                      contain
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <span class="pl-4"> {{ data.item.numcol }} {{ data.item.descol }} </span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              {{ selectedCmp?`Part. code: ${selectedCmp.codpar}`:'' }}
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                ref="partQta"
                v-model="selectedQta"
                :disabled="!selectedCmp"
                reverse
                outlined
                label="Quantità"
                :rules="[rules.required]"
                @input="$nextTick(()=>selectedQta=selectedQta.replace(/[^0-9]/g,''))"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-btn
                large
                color="primary"

                :disabled="+selectedQta<=0 || (listaColori.filter(item => (item.numcol !== selectedCmp.numcol)).length>1 && !selectedColor)"
                @click="addToCart(); dialogRicambi=false"
              >
                <v-icon large>
                  mdi-cart-plus
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  // import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'
  import SparepartsCart from '@/views/utility/components/SparepartsCart.vue'

  export default {
    name: 'SparePartsOrder',
    components: {
      SparepartsCart,
    },
    data () {
      return {
        loading: false,
        dialogRicambi: false,
        showCart: false,
        listaLinee: [],
        lineaSelected: {},
        components: [],
        selectedParts: null,
        selectedCmp: null,
        selectedQta: null,
        selectedColor: null,
        qtapart: null,
        rules: {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
        },
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'cart', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      parts () {
        var parts = [...new Set(this.components.map(item => { return { compo: item.compo, nomcom: item.nomcom, sez: item.sez } }))]
        console.log('parts', parts)
        // remove duplicate entry
        return parts
      },
      items () {
        console.log('selectedParts', this.selectedParts)
        var items = this.components.filter(itm => (itm.compo === this.selectedParts?.compo && itm.sez === this.selectedParts?.sez))

        // var items = this.tippar(this.parts[this.selectedParts]).map(item => { return { codart: item.codart, compo: item.compo, tippar: item.tippar, descompo: item.descompo, dir: item.dir } })

        console.log('items', items)
        return [...new Map(items.map(item => [item.tippar, item])).values()]// remove obj duplicate  items
      },
      listaColori () {
        if (!this.selectedCmp?.compo) {
          return []
        }
        var colori = this.components.filter(itm => (itm.codart === this.selectedCmp.codart && itm.compo === this.selectedCmp.compo && itm.tippar === this.selectedCmp.tippar && itm.sez === this.selectedCmp.sez))
        return colori.sort((a, b) => a.numcol - b.numcol)
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      this.listaLinee = this.clidata.anlin.filter(item => ['SWF', 'JOY', 'JOYBAB'].includes(item.label))
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_spareparts () {
        this.loading = true
        engine.get_spareparts(this.lineaSelected.label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.components = result.data
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      tippar (cmp) {
        console.log('cmp', cmp)
        var tippar = this.components.filter(item => item.nomcom === cmp)
        console.log('===>', tippar)
        return tippar.sort((a, b) => a.tippar - b.tippar)
      },
      filepath (dir, tippar) {
        console.log(`./img/${dir}/${this.lineaSelected.label}_${tippar}.png`)

        if (['NAS', 'FRO'].includes(dir)) {
          return `./img/${dir}/${tippar}.png`
        }

        return `./img/${dir}/${this.lineaSelected.label}_${tippar}.png`
      },

      addToCart () {
        var item = { ...this.selectedCmp, qta: this.selectedQta }
        // if (Object.keys(this.selectedCmp).length > 0) {
        this.$store.state.cart.push(item)
        this.$store.commit('setCart', this.$store.state.cart)
        // }
      },
      saveSpareparts (details) {
        console.log('saveSpareparts')
        this.loading = true
        engine.saveSpareparts(this.cart, details)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
            }
            this.$store.commit('setSnack', { message: result.message, color: '#4caf50', timeout: 5000 })
            this.lineaSelected = {}
            this.components = []
            this.$store.commit('setCart', [])
          })
          .catch((errore) => {
            console.log('api err: ', errore)
          }).finally(() => { this.loading = false })
      },
    },
  }

</script>
<style>
#riparazioni .bordered{
  border:1px solid #ccc;

}
</style>
